import { Injectable } from '@angular/core';
import { Business } from '@models/businesses';
import {
	Matter,
	PersonMatterClient,
	BusinessMatterClient,
} from '@models/matter';
import { AllAdjustmentsCalculated } from '@state/matter/adjustments/adjustments.selectors';
import { cloneDeep } from 'lodash';
import { BaseFormMapper } from '../../base-form-mapper';
import { NameFormattingSettings } from '@models/businessSettings/settings';

@Injectable({
	providedIn: 'root',
})
export class RBC_COLLATERAL_REQUEST_FOR_FUNDS_Mapper extends BaseFormMapper<RBC_COLLATERAL_REQUEST_FOR_FUNDS> {
	CloserToFormMappings = Mappings;

	mergeFormData(
		formData: RBC_COLLATERAL_REQUEST_FOR_FUNDS,
		matter: Matter,
		nameFormattingSettings: NameFormattingSettings,
		sellers: (PersonMatterClient | BusinessMatterClient)[],
		buyers: (PersonMatterClient | BusinessMatterClient)[],
		adjustments: AllAdjustmentsCalculated,
		business: Business,
	) {
		const _formData = formData
			? cloneDeep(formData)
			: ({} as RBC_COLLATERAL_REQUEST_FOR_FUNDS);

		return _formData;
	}

	MapValues(): Partial<RBC_COLLATERAL_REQUEST_FOR_FUNDS> {
		return {};
	}
}

const Mappings: RBC_COLLATERAL_REQUEST_FOR_FUNDS = {
	// "0":"topmostSubform[0]",
	// "1":"topmostSubform[0].Page2[0]",
	checkFundsNotRequired: 'topmostSubform[0].Page2[0].FUNDS_NOT_REQUIRED[0]',
	date: 'topmostSubform[0].Page2[0].MonthDayYear2[0]',
	// "4":"topmostSubform[0].Page2[0].signatureLawyerNotary[0]",
	registrationNumber: 'topmostSubform[0].Page2[0].REGISTRATION_NO[0]',
	mortgageInstructionDate2: 'topmostSubform[0].Page2[0].INSTRUCTIONS_DATED2[0]',
	mortgageinstructionsDate1: 'topmostSubform[0].Page2[0].INSTRUCTIONS_DATED[0]',
	protocolOf: 'topmostSubform[0].Page2[0].PROTOCOL_OF[0]',
	checkFundTransfer: 'topmostSubform[0].Page2[0].CHK_FUNDS_TRANSFER[0]',
	pickupCourierName: 'topmostSubform[0].Page2[0].courrierPickUp[0]',
	draftAmount: 'topmostSubform[0].Page2[0].DRAFT_LOAN_AMT[0]',
	lawFirmAddress: 'topmostSubform[0].Page2[0].NOTAIRE_ADRESSE[0]',
	lawyerName: 'topmostSubform[0].Page2[0].NOTAIRE_NOM_FOLIO[0]',
	financialInstitutionName: 'topmostSubform[0].Page2[0].TRUST_IF[0]',
	trustAccount: 'topmostSubform[0].Page2[0].TRUST_ACCOUNT[0]',
	bankTransitNumber: 'topmostSubform[0].Page2[0].TRUST_BRANCH[0]',
	bankNumber: 'topmostSubform[0].Page2[0].TRUST_INST[0]',
	creditAmount: 'topmostSubform[0].Page2[0].DISBURSED_NO_DOLLAR_SIGN[0]',
	fundsForwardDate: 'topmostSubform[0].Page2[0].DT_DEBOURS_YYYYMMDD[0]',
	// "20":"topmostSubform[0].Page1[0]",
	requestType: 'topmostSubform[0].Page1[0].CHK_FUNDS[0]',
	fundsRequired: 'topmostSubform[0].Page1[0].FUNDS_REQUIRED[0]',
	specificInstruction2: 'topmostSubform[0].Page1[0].SPECIFIC_INSTRUCTIONS2[0]',
	// "24":"topmostSubform[0].Page1[0].BARCODE_FAX_RETURN_LENDER[0]",
	specificInstruction1: 'topmostSubform[0].Page1[0].SPECIFIC_INSTRUCTIONS1[0]',
	propertyLROName: 'topmostSubform[0].Page1[0].DISCHARGE_LAND_REG_DIV[0]',
	mortgageRegistrationNumber: 'topmostSubform[0].Page1[0].DISCHARGE_REG_NUM[0]',
	propertyProvinceCode: 'topmostSubform[0].Page1[0].ADR_PROP1_CODE_PROVINCE[0]',
	propertyCity: 'topmostSubform[0].Page1[0].ADR_PROP1_VILLE[0]',
	propertyStreet: 'topmostSubform[0].Page1[0].ADR_PROP1_RUE1[0]',
	transitNumber: 'topmostSubform[0].Page1[0].BRCH_TRST[0]',
	creditApplicationNumber:
		'topmostSubform[0].Page1[0].CREDIT_APPLICATION_NUMBER[0]',
	clientSRF: 'topmostSubform[0].Page1[0].SRF_NUMBER[0]',
	secondClientLastName: 'topmostSubform[0].Page1[0].DEBITEUR2_NOM[0]',
	secondClientFirstName: 'topmostSubform[0].Page1[0].DEBITEUR2_PRENOM[0]',
	firstClientLastName: 'topmostSubform[0].Page1[0].BWRLASTNM_OR_COMPANYNAME[0]',
	firstClientFirstName: 'topmostSubform[0].Page1[0].DEBITEUR1_PRENOM[0]',
	checkQuebecOnlyType: 'topmostSubform[0].Page1[0].QC_NU_BOX[0]',
	checkAllprovinceType: 'topmostSubform[0].Page1[0].ROC_BOX[0]',
};

export interface RBC_COLLATERAL_REQUEST_FOR_FUNDS {
	requestType: string;
	checkAllprovinceType: string;
	checkQuebecOnlyType: string;

	firstClientFirstName: string;
	firstClientLastName: string;

	secondClientFirstName: string;
	secondClientLastName: string;

	clientSRF: string;
	creditApplicationNumber: string;
	transitNumber: string;

	propertyStreet: string;
	propertyCity: string;
	propertyProvinceCode: string;

	mortgageRegistrationNumber: string;
	propertyLROName: string;
	fundsRequired: string;

	specificInstruction1: string;
	specificInstruction2: string;

	fundsForwardDate: string;
	checkFundTransfer: string;
	creditAmount: string;
	trustAccount: string;
	bankTransitNumber: string;
	bankNumber: string;
	financialInstitutionName: string;

	lawyerName: string;
	lawFirmAddress: string;

	draftAmount: string;
	pickupCourierName: string;

	checkFundsNotRequired: string;
	protocolOf: string;
	mortgageinstructionsDate1: string;
	mortgageInstructionDate2: string;
	registrationNumber: string;

	date: string;

	// lenderReferenceNumber: string,
	// date: string,
	// mortgagors:string,
	// guarantors:string,

	// propertyCity: string,
	// // propertyProvince: string,
	// // propertyPostalCode: string,

	// mortgageAmount:string,
	// mortgageRegistrationNumber:string,
	// mortgageRegistrationDate:string,
	// taxesPaidInFullDate:string,
	// taxesPropertyCode:string,
	// titleOpinion:string,
	// titleInsuranceReferenceNumber:string,
	// titleInsurerName:string,
	// lawyerName:string,
	// exceptions:string,

	// bankTitle:string,
	// reportType:string,

	// checkDocument:string,
	// checkPolicy:string,
	// checkProtocol:string
}
